// pages/im/components/message-emitter/message-emitter.js
import { IMEventBus } from "lib/mp-stjk-im-service";

Component({
  /**
   * 组件的属性列表
   */
  properties: {
    nodeCreateTime: {
      type: Number,
      value: 0
    }
  },

  /**
   * 组件的初始数据
   */
  data: {
    showInput: true,
    showRobotMsg: false,
    robotMsg: {},
    inputProps: {},
  },

  ready: function () {
    // 展示机器人消息
    IMEventBus.addListener("robot_emitter", (showRobotMsg, robotMsg) => {
      console.log('lld::local-id='+this?.data?.robotMsg?.id+'  id='+robotMsg?.id+"  isReturn="+(this?.data?.robotMsg?.id>robotMsg?.id))
      if(!!robotMsg?.id&&this?.data?.robotMsg?.id>robotMsg?.id)
        return

      this.setData({
        showRobotMsg,
        robotMsg: robotMsg || {}
      });
    });
    // 展示输入框
    IMEventBus.addListener("input_emitter", (showInput, inputProps) => {
      this.setData({
        showInput,
        inputProps: !inputProps ? {} : inputProps
      });
    });
  },
  /**
   * 组件的方法列表
   */
  methods: {}
});
